<div class="flex items-center justify-center min-h-screen p-4 relative" style="background: linear-gradient(135deg, #1a1a2e 0%, #16213e 25%, #0f3460 50%, #1a6fa5 75%, #00a8e8 100%);">
  <p-toast key="http-error" position="bottom-right" />

  <!-- Versión y Ambiente en esquina inferior izquierda -->
  <div class="version-footer">
    <span class="version-text">v{{ appVersion }}</span>
    <span class="environment-text">{{ environmentName }}</span>
  </div>

  <div class="w-full max-w-lg">
    <p-card class="login-card">
      <!-- Logo -->
      <div class="text-center mb-6">
        <img src="assets/images/logo_completo_go_energy_400.png" alt="GOenergy Logo" width="400" height="111" class="max-w-[400px] h-auto mx-auto mt-2">
      </div>

      <!-- Formulario -->
      <form [formGroup]="form" class="pt-2 pb-4" (ngSubmit)="onLogin()">

        <!-- Email con validación -->
        <div class="mb-6">
          <p-floatlabel variant="on">
            <input
              pInputText
              id="email"
              type="email"
              formControlName="email"
              class="w-full"
              autocomplete="email"
            />
            <label for="email">Correo electrónico</label>
          </p-floatlabel>

          @if (emailControl.invalid && emailControl.touched) {
            <small class="text-red-500 mt-1 block pl-1">
              {{ emailControl.hasError('required') ? 'Ingresa tu correo electrónico' : 'Correo electrónico inválido' }}
            </small>
          }
        </div>

        <!-- Password -->
        <div class="mb-8">
          <p-floatlabel variant="on">
            <p-password
              inputId="password"
              formControlName="password"
              [toggleMask]="true"
              [feedback]="false"
              class="w-full"
              inputStyleClass="w-full"
              autocomplete="current-password"
            />
            <label for="password">Contraseña</label>
          </p-floatlabel>

          @if (passwordControl.hasError('required') && passwordControl.touched) {
            <small class="text-red-500 mt-1 block pl-1">Ingresa tu contraseña</small>
          }
        </div>

        <!-- Botón Login -->
        <p-button
          label="Ingresar"
          icon="pi pi-sign-in"
          type="submit"
          [loading]="loading"
          styleClass="w-full mt-3"
          severity="primary"
        />
      </form>
    </p-card>
  </div>
</div>
